import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { Paper } from '@mui/material';
import Button from './atoms/Button';
import PageHeader from './molecules/PageHeader';
import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import MessageBar from './atoms/MessageBar';
import { validateForm, checkFieldInObject } from '../helper';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const RegisterParents = ({
  formData,
  updateFormData,
  openDialog,
  setOpenDialog,
  checkDuplicateID,
}) => {
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState('');
  const [validation, setValidation] = useState({
    primary_parent_name: false,
    primary_parent_relationship: false,
    // primary_parent_identity_number: false,
    primary_parent_mobile: false,
    primary_parent_email: false,
    primary_parent_religion: false,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleFormChange = e => {
    const { name, value } = e.target;

    if (checkFieldInObject(name, validation)) {
      setValidation(prev => ({
        ...prev,
        [name]: false,
      }));
    }

    updateFormData(e.target, '', 'parents');
  };

  const handleParentRegistration = async () => {
    let isValid = true;
    if (await checkDuplicateID()) {
      console.log('open dialog');
      setOpenDialog(true);
    } else {
      setErrorMsg('');
      if (validateForm(validation, setValidation, formData.parents)) {
        navigate('/register/child');
      } else {
        setErrorMsg('Please fill in all required fields');
        window.scrollTo(0, 0);
      }
    }
  };

  const handleCheckDuplicateID = async () => {
    if (await checkDuplicateID()) {
      console.log('open dialog');
      setOpenDialog(true);
    }
  };
  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <PageHeader>Parental Information</PageHeader>

      {errorMsg !== '' && (
        <div>
          <MessageBar msg={errorMsg} />
          <div className='spacer'></div>
        </div>
      )}
      <Paper elevation={5} sx={{ padding: '20px' }}>
        <TextField
          label='Primary Contact (Full Name)'
          name='primary_parent_name'
          error={validation.primary_parent_name}
          helperText={
            validation.primary_parent_name && 'Please enter your name'
          }
          fullWidth
          required
          margin='dense'
          value={formData.parents.primary_parent_name}
          onChange={handleFormChange}
          inputProps={{ 'data-cy': 'primary-parent-name-input' }}
          id='primary_parent_name'
        ></TextField>

        <TextField
          label='Relationship To Student'
          name='primary_parent_relationship'
          fullWidth
          error={validation.primary_parent_relationship}
          helperText={
            validation.primary_parent_relationship &&
            'Please enter your relationship with the child / children'
          }
          required
          margin='dense'
          value={formData.parents.primary_parent_relationship}
          onChange={handleFormChange}
          inputProps={{ 'data-cy': 'primary-parent-relationship-input' }}
          id='primary_parent_relationship'
        ></TextField>

        {/* <TextField
          label='National ID Number (NRIC / FIN / Passport)'
          name='primary_parent_identity_number'
          error={validation.primary_parent_identity_number}
          helperText={
            validation.primary_parent_identity_number &&
            'Please enter your ID number'
          }
          fullWidth
          required
          margin='dense'
          value={formData.parents.primary_parent_identity_number}
          onChange={handleFormChange}
          onBlur={handleCheckDuplicateID}
          inputProps={{ 'data-cy': 'primary-parent-id-input' }}
          id='primary_parent_id'
        ></TextField> */}

        <TextField
          label='Primary Contact Mobile'
          name='primary_parent_mobile'
          fullWidth
          required
          error={validation.primary_parent_mobile}
          helperText={
            validation.primary_parent_mobile &&
            'Please enter your mobile number'
          }
          margin='dense'
          value={formData.parents.primary_parent_mobile}
          onChange={handleFormChange}
          inputProps={{ 'data-cy': 'primary-parent-mobile-input' }}
          id='primary_parent_mobile'
        ></TextField>

        <TextField
          label='Primary Email'
          name='primary_parent_email'
          fullWidth
          required
          error={validation.primary_parent_email}
          helperText={
            validation.primary_parent_email && 'Please enter your email address'
          }
          margin='dense'
          value={formData.parents.primary_parent_email}
          onChange={handleFormChange}
          inputProps={{ 'data-cy': 'primary-parent-email-input' }}
          id='primary_parent_email'
        ></TextField>

        <TextField
          label='Religion'
          name='primary_parent_religion'
          fullWidth
          select
          required
          error={validation.primary_parent_religion}
          helperText={
            validation.primary_parent_religion && 'Please select your religion'
          }
          margin='dense'
          value={formData.parents.primary_parent_religion}
          onChange={handleFormChange}
          inputProps={{ 'data-cy': 'primary-parent-religion-input' }}
          id='primary_parent_religion'
        >
          <MenuItem value='catholic'>Catholic</MenuItem>
          <MenuItem value='non-catholic'>Non-Catholic</MenuItem>
        </TextField>
      </Paper>
      <div className='spacer'></div>
      <Paper elevation={5} sx={{ padding: '20px' }}>
        <span style={{ fontSize: '0.8em' }}>~ Optional ~</span>
        <TextField
          label='Secondary Contact (Full Name)'
          name='sec_parent_name'
          fullWidth
          margin='dense'
          value={formData.parents.sec_parent_name}
          onChange={handleFormChange}
          inputProps={{ 'data-cy': 'sec-parent-name-input' }}
        ></TextField>

        <TextField
          label='Relationship To Student'
          name='sec_parent_relationship'
          fullWidth
          margin='dense'
          value={formData.parents.sec_parent_relationship}
          onChange={handleFormChange}
          inputProps={{ 'data-cy': 'sec-parent-relationship-input' }}
        ></TextField>

        <TextField
          label='Secondary Contact Mobile'
          name='sec_parent_mobile'
          fullWidth
          margin='dense'
          value={formData.parents.sec_parent_mobile}
          onChange={handleFormChange}
          inputProps={{ 'data-cy': 'sec-parent-mobile-input' }}
        ></TextField>

        <TextField
          label='Secondary Email'
          name='sec_parent_email'
          fullWidth
          margin='dense'
          value={formData.parents.sec_parent_email}
          onChange={handleFormChange}
          inputProps={{ 'data-cy': 'sec-parent-email-input' }}
        ></TextField>

        <TextField
          label='Religion'
          name='sec_parent_religion'
          fullWidth
          select
          margin='dense'
          value={formData.parents.sec_parent_religion}
          onChange={handleFormChange}
          inputProps={{ 'data-cy': 'sec-parent-religion-input' }}
          id='sec_parent_religion'
        >
          <MenuItem value='catholic'>Catholic</MenuItem>
          <MenuItem value='non-catholic'>Non-Catholic</MenuItem>
        </TextField>
      </Paper>
      <div className='spacer'></div>
      <div className='right'>
        <Button
          variant='contained'
          callback={handleParentRegistration}
          testid='register-child-button'
        >
          Register Child
        </Button>
      </div>

      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        id='duplicate-alert-dialog'
      >
        <DialogTitle id='alert-dialog-title'>
          {'Previous Registration Found'}
        </DialogTitle>
        <DialogContent>
          A Parent with the ID{' '}
          <span className='font-bold underline'>
            {formData.parents.primary_parent_identity_number}
          </span>{' '}
          has already completed a previous registration.
          <div className='pb-4'>Please select an option below:</div>
          <div className='flex items-center pb-2 font-bold'>
            <KeyboardArrowRightIcon />{' '}
            <Link
              to={`/register/continue?id=${formData.parents.primary_parent_identity_number}`}
              id='add-child-link'
            >
              Add a child to the previous registration
            </Link>
          </div>
          <div className='flex items-center pb-2 font-bold'>
            <KeyboardArrowRightIcon />{' '}
            <Link
              to={`http://localhost:3000/register/upload?id=${formData.parents.primary_parent_identity_number}`}
              id='upload-doc-link'
            >
              Upload documents for the registered
            </Link>
            &nbsp;child / children
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default RegisterParents;
